<template lang="pug">
.gzzoc-pdf-wrapper
    .gzzoc-pdf
        img.logo(src="~public/images/gzzoc/logo-pdf.png", width="267")
        .title
            | {{$t('gzzoc.reportTitle')}}
        .person
            .item
                |{{$t('gzzoc.age')}}: {{result.age}}
        .capture-dom(v-if="showCapture")
        .result-wrapper.thin-border-top
            .result-content(v-for='(item, index) in result.report')
                .result-item
                    .result-title {{item.side}}
                    .result-description.result-small-text
                        label {{$t('gzzoc.sphericalEquivalent')}}: {{item.SE}}
                        label {{$t('gzzoc.bcVisualAcuity')}}: {{item.BCVA}}
                        label {{$t('gzzoc.prPrevYear')}}: {{item.PR}}
                .result-item.thin-border-top
                    .result-title {{$t('gzzoc.fiveYearResult', {year: result.ttl})}}
                    .result-description.has-big-font
                        label {{item.side}}：{{item.value}}
                    .result-description.result-small-text
                        div {{item.explain}}
                    .result-description.has-big-font
                        label {{item.value < -6.0 ? $t('gzzoc.myopiaHighRisk') : $t('gzzoc.myopiaLowRisk')}}
        .tips.thin-border-top
            div.advice {{$t('gzzoc.myopiaTip')}}
            div {{$t('gzzoc.normalRange')}}-0.5~+0.5
            div {{$t('gzzoc.qingdu')}}<-0.5
            div {{$t('gzzoc.gaodu')}}<-6.0
            div {{$t('gzzoc.yuanshi')}}>+0.5
        .tips.thin-border-top
            .tip-title {{$t('projectDesc')}}
            .tip-content(v-html='result.model_remark')

</template>

<script>
import _ from 'lodash';
import { languages, loadLanguageAsync } from "@/locale";

export default {
    data () {
        return {
            result: {
                report: []
            },
            showCapture: false
        };
    },
    computed: {
        id () {
            return this.$route.params.taskId;
        },
        date () {
            return this.$route.params.date;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        }
    },
    async mounted () {
        let lang = _.get(this.$route, 'params.lang');
        if (lang) {
            await loadLanguageAsync(lang);
        }
        this.getResult();
    },
    methods: {
        imgsrc (src) {
            return '/api/upl/s3/download/big/file?_id=' + src;
        },
        getResult () {
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: this.id,
                    lang: this.lang.lang
                }
            }).then(resp => {
                const status = _.get(resp, 'body.value.data.status');
                // 成功
                if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    return;
                }
            }).finally(() => {
                this.$nextTick(() => {
                    setTimeout(() => { // 解决截图中存在loading状态的bug
                        this.showCapture = true;
                    }, 300);
                });
            });
        }
    }

};
</script>

<style lang="sass" scoped>
.gzzoc-pdf-wrapper
    width: 100%
    height: 100%
    background-color: #FFF
    overflow-y: hidden
.gzzoc-pdf
    background-color: #FFF
    margin: 0 auto
    color: #000
    transform-origin: top center
    transform: scale(0.8, 0.8)
    .logo
        width: 196px
        height: 28px
    .title
        font-family: STSongti-SC-Black
        font-size: 24px
        line-height: 24px
        text-align: center
        margin-top: 21px
        white-space: pre-wrap
    .person
        font-family: STSongti-SC-Regular
        font-size: 12px
        color: #000000
        line-height: 12px
        padding-top: 20px
        padding-bottom: 15px
        display: flex
        justify-content: center
        .item
            display: inline-block
            margin: 0 30px
    .result-wrapper
        display: flex
        flex: 1 1
        justify-content: center
        .result-content
            width: 340px
            &:not(:last-child)
                margin-right: 34px
        .result-item
            padding-top: 50px
            padding-bottom: 50px
            &:last-child
                border-bottom: none
            .result-title
                font-family: STSongti-SC-Regular
                font-size: 12px
                line-height: 17px
                color: #000
            .result-description
                font-family: STSongti-SC-Regular
                font-size: 12px
                line-height: 17px
                color: #000
                margin-top: 5px
                label
                    display: inline-block
                    width: 45%
                    margin-right: 5%
                    vertical-align: top
                &.has-big-font
                    label:first-child
                        font-family: STSongti-SC-Bold
                        font-size: 18px
                        line-height: 25px
                        display: block
                        width: 100%
                &.result-small-text
                    font-size: 12px
                    line-height: 17px
    .result-advice
        padding-top: 50px
        padding-bottom: 50px
        .advice-title
            font-family: STSongti-SC-Bold
            font-size: 18px
            line-height: 25px
            color: #000000
            text-align: left
        .advice-description
            font-family: STSongti-SC-Regular
            font-size: 12px
            line-height: 17px
            margin-top: 5px
            color: #000000
    .tips
        font-family: STSongti-SC-Regular
        font-size: 12px
        line-height: 17px
        color: #000000
        padding-top: 50px
        padding-bottom: 50px
        div
            margin-top: 5px
            &.advice
                margin-bottom: 10px
</style>
